import React from 'react';

import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';

import {Messages} from 'commons/constants';
import {InferPropTypes} from 'commons/types/Types';
import SignatureInnerForm from './SignatureInnerForm';
import {DigitalizedSignatureValues} from 'commons/models/modules/content/DigitalizedSignatureValues';

SignatureForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof SignatureForm.propTypes>,
    DigitalizedSignatureValues
>({
    mapPropsToValues: () => {
        return {
            signature: '',
            informationCheck: false,
        };
    },
    mapPropsToErrors: () => {
        return {
            signature: '',
            informationCheck: '',
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: DigitalizedSignatureValues) => {
        const errors: FormikErrors<DigitalizedSignatureValues> = {};
        if (!values.signature) {
            errors.signature = Messages.SIGNATURE_NOT_CAPTURED;
        }

        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(SignatureInnerForm);

function SignatureForm(props: InferPropTypes<typeof SignatureForm.propTypes>) {
    const {submitHandler} = props;

    return (
        <div className='SignatureForm'>
            <FormControl submitHandler={submitHandler} />
        </div>
    );
}
export default SignatureForm;
